import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientRole } from '../types';
import { getSavedRole, saveRole } from '../services/roleStorage';
import './HomePage.css';

/** Выбор роли: телевизор или пульт. */
export const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const role = getSavedRole();
    if (role === 'display') navigate('/tv', { replace: true });
    if (role === 'dj') navigate('/dj', { replace: true });
  }, [navigate]);

  const choose = (role: ClientRole) => {
    saveRole(role);
    navigate(role === 'display' ? '/tv' : '/dj');
  };

  return (
    <div className="home-page">
      <p className="home-kicker">Музыкальное лото</p>
      <h1 className="home-title">Кто сегодня этот экран?</h1>
      <div className="home-cards">
        <button type="button" className="home-card" onClick={() => choose('display')}>
          <span className="home-card-label">Я телевизор</span>
          <span className="home-card-hint">Сетка, названия и звук</span>
        </button>
        <button type="button" className="home-card home-card-dj" onClick={() => choose('dj')}>
          <span className="home-card-label">Я пульт</span>
          <span className="home-card-hint">Номера, стоп и сыгранные</span>
        </button>
      </div>
    </div>
  );
};
